import { useMutation } from '@tanstack/react-query';
import { message } from 'antd';
import { I18n } from '@aws-amplify/core';
import Api from '@/services/api';
import type { BoardType } from '@/types';

type Task = {
	description: string;
};

type ActionPlan = {
	title: string;
	board: BoardType;
	deadline?: Date;
	description?: string;
	responsible_user_id: string;
	tasks?: Task[];
};

type CreateRosaActionPlanRequest = {
	organization_id: string;
	company_id: string;
	report_id: string;
	category_id: string;
	action_plan: ActionPlan;
};

type CreateRosaActionPlanResponse = {
	id: string;
	report_id: string;
	action_plan_id: string;
	category_id: string;
	updated_at: Date;
	created_at: Date;
};

async function createRosaActionPlan(params: CreateRosaActionPlanRequest): Promise<CreateRosaActionPlanResponse> {
	const url = `/ergonomic-tool/rosa/action-plan/${params.report_id}`;
	const { data } = await Api.post<CreateRosaActionPlanResponse>(url, params);
	return data;
}

export const useCreateRosaActionPlan = () => {
	return useMutation<CreateRosaActionPlanResponse, any, CreateRosaActionPlanRequest>(
		(payload) => createRosaActionPlan(payload),
		{
			onSuccess: () => {
				message.success(I18n.get('Action plan created successfully'));
			}
		}
	);
};
